import $ from 'jquery';
import * as config from '../../../home24/core/config';

export default function AddressCheckService(url) {
  var baseUrl = config.getBaseUrl() + '/myaccount/addresscheck/check';

  this._config = {
    url: url || baseUrl
  };
}

AddressCheckService.prototype = {
  sendRequest: function(addressArray, successHandler, failureFailure) {
    $.ajax({
      url: this._config.url,
      data: addressArray,
      dataType: 'json',
      success: successHandler,
      error: failureFailure
    });
  }
};



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/helpers/addressCheck/addressCheckService.js
 **/